<template>
  <div class="container">
    <!-- <SimpleHeader /> -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="tbflexBox">
        <div class="tbflexBox-one">
          <span class="tbflexBox-one_top">{{ balanceUnit(info.todayBonus).balance }}</span>
          <span class="tbflexBox-one_bottom">今日</span>
        </div>
        <div class="tbflexBox-one">
          <span class="tbflexBox-one_top">{{ balanceUnit(info.monthBonus).balance }}</span>
          <span class="tbflexBox-one_bottom">本月</span>
        </div>
        <div class="tbflexBox-one">
          <span class="tbflexBox-one_top highlightcolor">{{ balanceUnit(info.totalBonus).balance }}</span>
          <span class="tbflexBox-one_bottom">累计</span>
        </div>
      </div>

      <div class="lineStructure">
        <div class="linecont" v-for="(item, index) in list" :key="index" @click="toPage(item.status)">
          <div class="linecontleft">
            <span class="linecontleft-title">{{ item.statusTxt }}</span>
          </div>
          <div class="linecontright">
            <span class="linecontright-title">¥{{ item.bonus }}</span>
            <img class="linecontright-icon iconRight" src="https://x.jzbull.com/x_dsx_h5/icons/icon-right.png" alt="" />
          </div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import SimpleHeader from '@/components/SimpleHeader'
import { onMounted, nextTick, ref } from 'vue'
import { useRouter } from 'vue-router'
import { showToast, PullRefresh } from 'vant'
import { getBonusSummary } from '@/api/bonus'
import usePage from '@/hooks/usePage'
import { balanceUnit } from '@/common/js/utils'

export default {
  name: 'bonusWho',
  components: {
    [PullRefresh.name]: PullRefresh,
    SimpleHeader
  },
  setup() {
    const info = ref({})
    const router = useRouter()
    const { navigateTo } = usePage()
    // 下拉刷新页面
    const refreshing = ref(false)
    const loading = ref(false)
    const list = ref([])
    function toPage(status) {
      navigateTo(`/bonusDetail?flag=${status}`)
    }
    const onRefresh = () => {
      refreshing.value = false
      loading.value = true
      getInfo()
    }

    async function getInfo() {
      const res = await getBonusSummary()
      list.value = res.list
      info.value = res
      // 重置选项获取最新数据
      setTimeout(() => {
        loading.value = false
      }, 300)
    }

    onMounted(async () => {
      getInfo()
    })

    nextTick(() => {
      window.addEventListener('scroll', () => {})
    })

    const goToDetail = item => {
      router.push({ path: `/product/${item.goodsId}` })
    }

    const tips = () => {
      showToast('敬请期待')
    }
    function toDetail() {
      navigateTo('/teamDetail?id=1')
    }

    return {
      goToDetail,
      tips,
      toDetail,
      refreshing,
      loading,
      onRefresh,
      list,
      toPage,
      info,
      balanceUnit
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../common/style/searchpicker';

.tbflexBox {
  .tbflexBox(28px);
}
.lineStructure {
  background: #ffffff;
  padding: 0 15px;
  .linecont {
    .linecont(56px);
  }
  .linecont:last-child {
    border-bottom: 0;
  }
}
.highlightcolor {
  color: #ff6060;
}

.container {
  background: #f8f8f8;
  width: 100%;
  height: 100%;
  position: relative;
}
.searchBlock {
  margin: 10px 0;
  height: 36px;
  display: flex;
  align-items: center;
}
.mb10 {
  margin-bottom: 10px;
}
.tabBlock {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 98px;
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 21px;
  }
  &-self {
    .biswh('https://x.jzbull.com/x_dsx_h5/bg/bg-one.png', 168px, 98px);
  }
  &-team {
    .biswh('https://x.jzbull.com/x_dsx_h5/bg/bg-team.png', 168px, 98px);
    margin-left: auto;
  }
  &-num {
    display: flex;
    align-items: flex-end;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
  }
  .signal {
    font-size: 12px;
    line-height: 17px;
  }
  .title {
    font-size: 14px;
    color: #fff;
    font-weight: bold;
  }
}
.agentBlock {
  display: flex;
  flex-direction: column;
  &-cont {
    width: 345px;
    height: 98px;
    opacity: 1;
    background: #ffffff;
    // border-radius: 12px;
    margin-bottom: 10px;
    display: flex;
    > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 22px 0;
      justify-content: space-between;
    }
    &_onetitle {
      color: #666666;
      line-height: 20px;
      font-size: 14px;
    }
    &_onenum {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: #333333;
      line-height: 33px;
      font-size: 24px;
    }
    .agentSignal {
      color: #333333;
      line-height: 22px;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
